import React, { useEffect, useState } from 'react';

// third-party imports
import { Link } from 'react-scroll';

// project-imports
import Image from '../../common/footer/Images/Image';
import ToolTip from '../../common/Tooltip/ToolTip';
import { GoogleAnalyticsEnum, triggerFunction } from '../../utils/google-analytics';
import { useProductContext } from '../../context/product_context';
import { formatCurrency, handleDiscountedPrice } from '../../utils/course';
import Spinner from '../../components/spinner-component/SpinnerOne';
import TalkToSalesForm from './TalkToSalesForm';
import { maskPrice } from '../../utils';
import { useNavigate } from 'react-router-dom';

// Reading env variable
const TYPE_DEVELOPER = process.env.REACT_APP_OFFERING_TYPE_DEVELOPER;
const TYPE_ADMIN = process.env.REACT_APP_OFFERING_TYPE_ADMIN;

function TrainingProgramsTwo({ data, bgWhite, code }) {
    // Reading variables and methods from context
    const { productLoading } = useProductContext();

    const navigate = useNavigate();

    // State intialization
    const [showTalkToSalesModal, setShowTalkToSalesModal] = useState(false);

    // constant variable
    const type = data?.category === "salesforce" && data?.subCategory === "administration" ? TYPE_ADMIN : TYPE_DEVELOPER;

    // handle function to navigate to detail page
    const handleNavigateDetail = (data) => {
        try {
            navigate(
                `/our-offerings/${type}/${data?.productCode?.toLowerCase()}`
            );
            triggerFunction(
                GoogleAnalyticsEnum.BUTTON,
                GoogleAnalyticsEnum.SF_TRAINING_PROGRAMS_DETAIL_VIEW
            );
        } catch (error) {
            console.log(
                "89 : EBookListingOne : Error in handleOpenDrawer : ",
                error && JSON.stringify(error)
            );
        }
    };

    // for format product name
    const handleFormatProductName = (productName) => {
        try {
            return productName
                ?.trim()
                ?.toLowerCase()
                ?.replaceAll("(3 months)", "")
                ?.replaceAll("(6 months)", "")
                ?.replaceAll("(9 months)", "");
        } catch (error) {
            console.log(
                "63 : TrainingPrograms : Error in handleFormatProductName : ",
                error && JSON.stringify(error),
            );
        }
    };

    const handleMonthlyPrice = (plan) => {
        try {
            let amountInRupees = plan?.pricing?.price;
            const duration = plan?.pricing?.billingCycle;

            if (duration) {
                if (duration === "3 Months") {
                    amountInRupees = Math.round(amountInRupees / 3);
                } else if (duration === "6 Months") {
                    amountInRupees = Math.round(amountInRupees / 6);
                } else if (duration === "9 Months") {
                    amountInRupees = Math.round(amountInRupees / 9);
                }
            }

            if (!amountInRupees) {
                return {
                    isValid: false,
                    finalAmount: 0,
                    formattedAmount: "₹ 0",
                };
            }
            let finalAmount = amountInRupees;

            // Format into INR currency string
            const formattedAmount = formatCurrency(finalAmount);

            return {
                finalAmount,
                formattedAmount,
            };
        } catch (error) {
            console.log(
                "101 : TraningPrograms : Error in handleDMonthlyPrice => ",
                error,
            );
            const fallback = plan?.pricing?.price || 0;
            return {
                finalAmount: fallback,
                formattedAmount: `₹ ${fallback.toLocaleString("en-IN")}`,
            };
        }
    };

    const isDiscountValid = (data) => {
        try {
            if (
                data?.discount?.hasDiscount &&
                handleDiscountedPrice(data, false)?.isValid
            ) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.log(
                "141 : TraningPrograms : Error in isDiscountValid : ",
                error && JSON.stringify(error),
            );
        }
    };

    const toggleTalkToSalesModal = () => {
        try {
            setShowTalkToSalesModal(!showTalkToSalesModal);
        } catch (error) {
            console.error(
                "114 : TestimonialForm : Error occurred in toggleTalkToSalesModal:",
                error && JSON.stringify(error)
            );
        }
    };

    return (
        <>
            {(productLoading) && <Spinner />}
            <div class={`edu-blog-widget-2 widget-latest-post mt--10`}>
                <div class="inner">
                    <div class="content bg-post latest-post-list">
                        <div class="flex-column flex-sm-row align-items-start latest-post">
                            <div class="thumbnail">
                                <div className="d-block training-programs-image">
                                    <Image src={`/images/offerings/${data?.media?.shortThumbnailUrl}`} alt="Thumbnail" className='training-programs-image' fill />
                                </div>
                                {isDiscountValid(data) && <div class="top-position status-group left-top"><span class="eduvibe-status status-08 bg-secondary-color mnt--0">{data?.discount?.discountPercent}% Off</span></div>}
                            </div>
                            <div className='content-left text-start'>
                                <div class="post-content">
                                    <ToolTip
                                        title={"View Deails"}
                                        id={"pricingDetail"}
                                        placement="bottom"
                                    >
                                        <h5
                                            className="title text-capitalize clickable"
                                            onClick={() => handleNavigateDetail(data)}
                                        >
                                            {handleFormatProductName(data?.name)}
                                        </h5>
                                    </ToolTip>
                                    <ul className="blog-meta">
                                        <li>
                                            <i className="icon-time-line"></i>(
                                            {data?.pricing?.billingCycle})
                                        </li>
                                        <li>
                                            <div className="price-list price-style-03">
                                                {isDiscountValid(data) && (
                                                    <div className="price old-price">
                                                        {maskPrice(handleMonthlyPrice(data).formattedAmount)}
                                                    </div>
                                                )}
                                                {isDiscountValid(data)
                                                    ? maskPrice(handleDiscountedPrice(data, true)?.formattedAmount)
                                                    : maskPrice(handleMonthlyPrice(data).formattedAmount)}
                                                <span className="fs-3 duration mx-1">
                                                    /{data?.pricing?.priceType}
                                                </span>
                                            </div>

                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <Link
                                        className="btn-transparent-2 color-primary clickable"
                                        onClick={toggleTalkToSalesModal}
                                    >
                                        Talk to Sales<i className="icon-arrow-right-line-right"></i>
                                    </Link>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {showTalkToSalesModal && (
                <TalkToSalesForm
                    show={showTalkToSalesModal}
                    data={data}
                    onCloseModal={toggleTalkToSalesModal}
                    title={"Submit Review"}
                    formStyle="rnt-contact-form rwt-dynamic-form row"
                />
            )}
        </>
    )
}

export default TrainingProgramsTwo;